import { PureFunctional, React } from '../../react';

import cx from './style.less';

export default PureFunctional<{ color: string, 
                                name: string, 
                                bold?: 
                                boolean, 
                                big?: boolean,
                                id?: string,
                                positionright?: boolean,
                             }>(`CategoryLabel`)(
    ({ color, name, bold, big, id, positionright }) => {
        return (
            <span className={cx('component', positionright ? 'positionright' : '', { bold, big })}>
                {positionright ? null:<span aria-hidden="true" className={cx('color', { bold, big })} style={{ backgroundColor: color }} />}
                <span id={id} className={cx('name', { bold, big })}>{name}</span>
                {positionright ? <span aria-hidden="true" className={cx('color', { bold, big })} style={{ backgroundColor: color }} /> : null}
            </span>
        );
    });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/categoryLabel/index.tsx